<template>
<div>
    <Modal
        class-name="vertical-center-modal"
        :value="showModel"
        :title="title"
        :footer-hide="true"
        :mask-closable="false"
        @on-cancel="cancel"
        @on-visible-change="openOrClose"  :styles="{'min-width':'700px'}">
        
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
    
            <FormItem :label="$t('userManage.addUserModel.titleName.signUpOptions')" prop="signUpOptions" class="ivu-form-item-required" style="width: 500px">
                <RadioGroup v-model="formData.signUpOptions">
                    <Radio :label="item.id" v-for="(item) in typeList" :key='item.id'>
                        <span>{{ item.name }}</span>
                    </Radio>
                </RadioGroup>
            </FormItem>

            <FormItem :label="$t('userManage.emailAddress')" :class="formData.signUpOptions==1?'ivu-form-item-required':''" prop="emailAddress"  style="width: 500px;">
                <Input type="text" v-model.trim="formData.emailAddress" :placeholder="$t('inputPlaceholder')"></Input>
            </FormItem>


            <FormItem :label="$t('userManage.phoneNumber')" :class="formData.signUpOptions==2?'ivu-form-item-required':''" prop="phoneNumber"  style="width: 500px;">
                <Input type="text" v-model.trim="formData.phoneNumber" :placeholder="$t('inputPlaceholder')"></Input>
            </FormItem>


            <FormItem :label="$t('userManage.addUserModel.titleName.countryCode')" :class="formData.signUpOptions==2?'ivu-form-item-required':''" prop="phonePrefix"  style="width: 500px;">
                <SearchSelectRecycle
                  :placeholderText="$t('userManage.addUserModel.selectPlaceholder.country')"  
                  :selectUrlQuery="{}"
                   refName="countryRef"   
                   ref="countryRef" 
                  labelName='country_label'  
                  isMultiple='2'  
                  valName='country_code' 
                  keyword="country_label" 
                  :labelInValue="true"  
                  @setSelected="setSelectValPage($event,'phonePrefix')"></SearchSelectRecycle>
            </FormItem>

            <FormItem :label="$t('appVersion.titleName.os')" prop="os" class="ivu-form-item-required" style="width: 500px">
                <RadioGroup v-model="formData.os">
                    <Radio :label="item.id" v-for="(item) in osList" :key='item.id'>
                        <span>{{ item.name }}</span>
                    </Radio>
                </RadioGroup>
            </FormItem>
            <FormItem>
                <Button :loading="disabled"  type="primary" @click="subData('formData')" style="margin-right:20px">{{$t('save')}}</Button>
                <Button :disabled="disabled" @click="cancel">{{$t('cancel')}}</Button>
            </FormItem>
        </Form>

    </Modal>
</div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import SearchSelectRecycle from './selectListCountry.vue';
import { mapState } from 'vuex'
import qs from 'qs'
    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            type:Number,
            editFormData:Object
        },
        name: "AddUserModel",
        components: {
            SearchSelectRecycle
        },
        data() {
            return {   
                disabled: false,//禁用确定按钮
                title: '',//弹框标题
                formData: {//表单数据
                   os:'1',
                   signUpOptions:'1',
                   emailAddress:'',
                   phoneNumber:'',
                   phonePrefix:''
                }, 
                
            }
        },
        watch:{
            'formData.signUpOptions'(newVal) {
               this.$nextTick(() => {
                 // 清除所有验证状态
                 this.$refs.formData.fields.forEach(field => {
                   field.validateMessage = '';
                   field.validateState = '';
                 });
                 // 强制重新验证
                 this.$refs.formData.validate();
               });
             }
        },
        computed:{
            ...mapState(["local", "selectId"]),
            typeList(){
                return [
                   { id: '1', name:  this.$t('userManage.emailAddress')},
                   { id: '2', name:  this.$t('userManage.phoneNumber')},
                ]
            },
            osList(){
                return [
                   { id: '1', name: 'andrios' },
                   { id: '2', name: 'ios' },
                ]
            },
            ruleCustom(){
                return {//验证
                    emailAddress: [
                       {
                          validator: (rule, value, callback) => {
                            if (this.formData.signUpOptions == 1) {
                              if (!value) {
                                callback(new Error(this.$t('required')));
                              } else {
                                // 可以加邮箱格式验证
                                callback();
                              }
                            } else {
                              callback(); // 非邮箱注册时不验证
                            }
                          },
                          trigger: 'blur'
                        },
                        {
                            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: this.$t('ruleCustom.email'),
                            trigger: 'blur'
                        }
                    ],
                    phoneNumber: [
                        {
                          validator: (rule, value, callback) => {
                            if (this.formData.signUpOptions == 2) {
                              if (!value) {
                                callback(new Error(this.$t('required')));
                              } else {
                                // 可以加邮箱格式验证
                                callback();
                              }
                            } else {
                              callback(); // 非邮箱注册时不验证
                            }
                          },
                          trigger: 'blur'
                        },
                        {
                            pattern: /^\+?[1-9]\d{1,15}$/,
                            message: this.$t('ruleCustom.phone'),
                            trigger: 'blur'
                        }
                    ],
                    phonePrefix: [
                        {
                          validator: (rule, value, callback) => {
                            if (this.formData.signUpOptions == 2) {
                              if (!value) {
                                callback(new Error(this.$t('required')));
                              } else {
                                // 可以加邮箱格式验证
                                callback();
                              }
                            } else {
                              callback(); // 非邮箱注册时不验证
                            }
                          },
                          trigger: 'blur'
                        },
                    ]
                }
            }

        },
        created(){
            
        },
        methods: {
            setSelectValPage(e,key){
                 this.formData[key] = e.country_code+''
            },
            openOrClose(value) {
                if(value === true) {    
                    this.title = this.$t('userManage.addUserModel.title')
                    this.$refs.countryRef.getData()
                   
                } else { //关闭弹框后要做的处理
                    this.resetForm();//重置表单
                    this.$refs.countryRef.clearVal()
                }
            },
            subData(name) {//提交表单
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.disabled = true;
                      
                        let params ={
                            ...this.formData,
                            dealerId:this.selectId
                        }
                       

                        // this.axios.post(this.config.urlArray.userGroupListShift, formDataArr).then((result) => {
                        //     common.ajaxMsg(result.data,true,()=>{//提交表单后的回调处理
                        //         this.resetForm();//重置表单
                        //         this.fn()
                        //     },()=>{this.disabled = false; })
                            
                        // }).catch((err) => {
                        //     common.msg('error','提交失败',()=>{this.disabled = false;})
                        // });
                        
                    }
                })
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
            },
            resetForm() {//重置表单
                this.$refs.formData.resetFields();//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
                Object.keys(this.formData).forEach(key=>{this.formData[key]=''})
                this.formData.os='1'
                this.formData.signUpOptions='1'
            }
        }
    }
</script>

<style lang="less" scoped>
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
</style>
